import React from 'react';
import { BookOpen } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useAccountPlaybookStatus } from './AccountPlaybookStatusContext';

export default function AccountPlaybookMarker({ accountId, className = "" }) {
  const { statuses, isLoading } = useAccountPlaybookStatus();
  
  if (isLoading || !statuses[accountId]) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button 
          className={`cursor-help ${className}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <BookOpen className="w-3.5 h-3.5 text-green-600 fill-green-100" />
        </button>
      </TooltipTrigger>
      <TooltipContent 
        side="top"
        align="center"
        className="bg-[#0A1A2F] text-white border-0 shadow-lg"
      >
        <p className="text-xs">Active in playbook</p>
      </TooltipContent>
    </Tooltip>
  );
}